import React from 'react'
import GiftcardAdd from '../components/Giftcards/GiftcardAdd'
import Sidebar from "../components/sidebar";
import Header from '../components/Header';

function GiftcardAddScreen() {
  return (
    <>
        <Sidebar />
        <main className="main-wrap">
            <Header />
            <GiftcardAdd />
        </main>
    </>
  )
}

export default GiftcardAddScreen